import script from "./BizConfigs.vue?vue&type=script&lang=ts&setup=true"
export * from "./BizConfigs.vue?vue&type=script&lang=ts&setup=true"

import "./BizConfigs.vue?vue&type=style&index=0&id=69d3e978&lang=scss"

const __exports__ = script;

export default __exports__